export const FUNCTIONAL_TEST = 'FUNCTIONAL_TEST'
export const FUNCTIONAL_TEST_ADMIN_USER = 'FUNCTIONAL_TEST_ADMIN_USER'
export const FUNCTIONAL_TEST_USER_EMAIL = 'FUNCTIONAL_TEST_USER_EMAIL'
export const FUNCTIONAL_TEST_USER_LOGIN_ID = 'FUNCTIONAL_TEST_USER_LOGIN_ID'
